import React, { useState, useEffect, useRef } from "react";
import { Stack } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { conflictDataActions, thumbnailStoreActions } from "../store/store";
import CloseIcon from '@mui/icons-material/Close';
import "./annotator.css";
import ThumbNailImage from "./Popup/ThumbNailImage";
import { setHoveredThumbnail, setIsHovered, setOpen } from "../store/ShelfView/popover";
// import MouseOverThumbnail from "../ShelfViewer/ShelfViewerThumbnailImage/MouseOverThumbnail";
import AnimatedPopup from "./Popup/AnimatedPopup";
import PopUp from "./conflicts/PopUp";
import { setClickedThumbnail, setOpenClicked } from "../store/ShelfView/conflictsPage";
import axios from "axios";
// const get_image_url = (image) => {
//     return (
//       `https://caiproduction002.blob.core.windows.net/ira/audit_images/` +
//       image +
//       `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
//     );
// };
const get_image_url = async (image) => {
	try {
		const urlData = await axios.post("/get_context/getImageURL", {
			"imageName": image,
			"folderName":"audit_images"
		})
		const imageUrl = urlData.data;
		console.log(imageUrl,"LINE 51")
		return imageUrl
	} catch (error) {
		console.error("Error fetching image:", error.message);
		return null;
	}
};

const GenerateThumbnail = (props) => {
 // console.log("thumbnail props", props)
    const dispatch = useDispatch();
    const {open,isHovered}=useSelector((state)=>state.popoverStore);
    const {zoomDynamicHeight } = useSelector(state => state.shelfViewFeedbackStore)
    const imageUrl = get_image_url(props.imageName);
    const xmin = props.xmin;
    const ymin = props.ymin;
    const xmax = props.xmax;
    const ymax = props.ymax;
    const canvasRef = useRef(null);
    const [cropDim, setCropDim] = useState([]);
  
    const [clicked,setClicked]=useState(false)
    const [anchor, setAnchor] = React.useState(null);

    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, xmax - xmin, ymax - ymin);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageUrl;
      img.onload = async () => {
        const cropX = xmin; // X-coordinate of the top-left corner of the crop area
        const cropY = ymin; // Y-coordinate of the top-left corner of the crop area
        const cropWidth = xmax - xmin; // Width of the crop area
        const cropHeight = ymax - ymin; // Height of the crop area
  
        setCropDim([cropWidth, cropHeight]);
  
        canvas.width = cropWidth;
        canvas.height = cropHeight;
        ctx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
      };
    }, [imageUrl, xmin, xmax, ymin, ymax]);
  
    const width = cropDim[0];
    const height = cropDim[1];
  
    const ratio = width / height;
    const dynamicHeight = zoomDynamicHeight;
    const dynamicWidth = dynamicHeight * ratio;

    const handleMouseEnter = (props) => {
     dispatch(setIsHovered(true));
     //dispatch(setOpen(true))
     dispatch(setHoveredThumbnail(props))
     //console.log(props)
    };
  
    const handleMouseLeave = () => {
      dispatch(setIsHovered(false))
      
      // dispatch(setHoveredThumbnail(null))
    };
    // console.log(props)
    const handleClick=(event)=>{
     
      setClicked((prevValue)=>!prevValue)
      dispatch(setClickedThumbnail(props))
      setAnchor(anchor ? null : event.currentTarget);
      dispatch(setOpenClicked(Boolean(anchor ? null : event.currentTarget)));
    
  }
    return (
      <div className="thumbnail">
        <canvas
          ref={canvasRef}
          style={{ width: dynamicWidth + `px`, height: dynamicHeight + `px` }}
          onMouseEnter={() =>handleMouseEnter(props)}
          onMouseLeave={() =>handleMouseLeave() }
         
        />

        {props.discarded && <CloseIcon 
          className="discard-icon" 
          sx={{
            fontSize: "1rem"
          }}
        />}
         {clicked&&<PopUp anchor={anchor} setAnchor={setAnchor}/>}
      
      </div>
    );
  };

  export default GenerateThumbnail;